import { Component, ElementRef, Input, QueryList, ViewChild, ViewChildren, ChangeDetectionStrategy } from '@angular/core';
import { NavigationLink } from './navigation-link';
import { MatTabLink } from '@angular/material/tabs';
import { BaseComponent } from '@shared/component/base/base.component';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class NavigationComponent extends BaseComponent {
  @ViewChildren(MatTabLink) tabLinks: QueryList<MatTabLink>;
  @ViewChild('swiper') swiper: ElementRef<HTMLElement & { swiper: { slideTo: (index: number) => void } }>;
  @Input() links: NavigationLink[];
  // tabs classes: primary/secondary/light
  @Input() inputClass: string = 'primary';

  slideToActiveTab(index: number): void {
    this.swiper?.nativeElement?.swiper?.slideTo(index);
  }
}
